import {
  CloseButton,
  ListContext,
  ListContextValue,
  Stack,
  Typography,
  ValidationErrors,
  newToast,
} from "@compass/core";
import { SubmitButton } from "components";
import { Provider } from "generated/openApi";
import { useContext } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setAppToast } from "redux/reducers/appSlice";
import ApiService from "services/apiService";
import { providerPageRoute } from "../ProviderPage/ProviderPage";
import { ProviderCreateContext, ProviderCreateContextValue } from "./ProviderCreatePage";

export const ProviderPageHeader = (props: {
  handle: string;
  provider: Provider;
  setValidationErrors: (errors: ValidationErrors) => void;
  unsavedChanges: boolean;
  closeOnSave?: boolean;
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const listContext = useContext<ListContextValue>(ListContext);
  const providerCreateContext = useContext<ProviderCreateContextValue>(ProviderCreateContext);

  const save = (provider: Provider) => {
    props.setValidationErrors({});

    ApiService.providers
      .saveCreate(provider)
      .then((response) => {
        const id = response;
        if (props.closeOnSave) navigate(`../`);
        else navigate(`../${providerPageRoute.getPath({ id: id, crudMode: "view", screenType: "dialog" })}`);

        listContext.loadList?.();
        providerCreateContext?.onCreate?.(id);
        dispatch(setAppToast(newToast("success")));
      })
      .catch((ex) => {
        dispatch(setAppToast(newToast("error")));
        props.setValidationErrors(ex.response);
      });
  };

  return (
    <Stack direction="row" justifyContent="space-between">
      <Typography variant="inherit">{props.handle}</Typography>

      <Stack direction="row" alignItems="center" spacing="sm">
        <CloseButton confirm={props.unsavedChanges} />
        <SubmitButton onClick={() => save(props.provider)} disabled={props.provider.id > 0 && !props.unsavedChanges} />
      </Stack>
    </Stack>
  );
};
